import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@services/user/user.service';

export interface DialogData {
  isActive: boolean;
  id: string;
}

@Component({
  selector: 'app-open-dialog-is-active',
  templateUrl: './open-dialog-is-active.component.html',
  styleUrls: ['./open-dialog-is-active.component.scss'],
})
export class OpenDialogIsActiveComponent implements OnInit {
  send = false;
  constructor(
    public dialogRef: MatDialogRef<OpenDialogIsActiveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private userService: UserService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  ActiveUser(): void {
    const id = this.route.snapshot.queryParams.id;
    this.userService.ActiveUser(this.data.id, this.data.isActive).subscribe({
      next: () => {
        this.send = true;

        setTimeout(() => {
          this.dialogRef.close();
        }, 3000);
      },
    });
  }
}
